module.exports = __webpack_public_path__ + "img/mobilmasodikbek.0a9eb938.svg";